(function() {
'use strict';

angular
    .module('TR')
    .controller('RecentHotels', RecentHotels);

function RecentHotels(urlUtils, $scope, $location, recentHotels, authService) {
    const cm = this;

    cm.clear = clear;
    cm.loading = true;
    cm.match = match;
    cm.remove = remove;
    cm.select = select;
    cm.signIn = signIn;

    authService.bufferRoute(null);
    _loadHotels();
    $scope.$on('auth:signout', _loadHotels);

    function _loadHotels() {
        recentHotels.get().then(function(hotels) {
            cm.hotels = hotels;
            cm.loading = false;
        });
    }

    function _contains(str, f) {
        return f == null ? true : str.toLowerCase().indexOf(f) > -1;
    }

    function clear() {
        recentHotels.clear().then(function() {
            cm.hotels = [];
        });
    }

    function remove(event, hotel) {
        event.preventDefault();
        event.stopPropagation();

        recentHotels.remove(hotel.Id).then(_loadHotels);
    }

    function select(hotel) {
        $location.path(urlUtils.stripLeadingSlash(hotel.Url));
    }

    function match(hotel) {
        return _contains(hotel.Name, cm.filter) || _contains(hotel.Location, cm.filter);
    }

    function signIn() {
        const url = 'recenthotels';
        authService.bufferRoute(url);
        $location.url(`signin?cb=${encodeURIComponent(url)}`);
    }
}
})();
